module.exports = __webpack_public_path__ + "static/img/logo.5cbc1e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo.png
// module id = 7Ogj
// module chunks = 1